import React from 'react'
import { connect, ConnectedComponent } from 'react-redux'
import { NegotiationDetail, NegotiationPackageDetail } from 'api'
import { ActionsRendererProps } from 'view/components/datagrid'
import { getSelectedNegotiationsForNegotiationPackageSelector } from './CurveNegotiationGridSelectors'
import { createStructuredSelector } from 'reselect'
import { isNil } from 'lodash'

interface SelectedCurveItemsProps extends ActionsRendererProps<NegotiationPackageDetail> {
  getSelectedNegotiationsForNegotiationPackage: (negotiationPackage: NegotiationPackageDetail) => NegotiationDetail[]
}

export function withSelectedCurveItems(
  Component: React.ComponentType<ActionsRendererProps<NegotiationDetail>> | ConnectedComponent<any, any>
) {
  class SelectedCurveItems extends React.Component<SelectedCurveItemsProps> {
    render() {
      const { data: negotiationDetail } = this.props
      if (isNil(negotiationDetail)) {
        return null
      }

      const items = this.props.getSelectedNegotiationsForNegotiationPackage(negotiationDetail)
      return <Component {...this.props} selectedItems={items} />
    }
  }

  const mapStateToProps = createStructuredSelector({
    getSelectedNegotiationsForNegotiationPackage: getSelectedNegotiationsForNegotiationPackageSelector
  })

  return connect(mapStateToProps, null, null, {
    forwardRef: true
  })(SelectedCurveItems)
}
